module.exports = __webpack_public_path__ + "zoom_out_map-v1-eb8f34b7.svg";